import { Alert } from 'antd';
import type { AlertProps } from 'antd';
import type { AlertRef } from 'antd/es/alert/Alert';
import './app-alert.css';
import { appAlertIcons } from '../alert.utils';
import { forwardRef } from 'react';

/**
 * AppAlert is a custom wrapper around Ant Design's Alert.
 *
 * - Automatically injects a default icon (except for 'warning' type)
 * - Applies a default className: 'app-alert
 * - Fully customizable via AlertProps
 *
 * @param {AlertProps} props - Same props as Ant Design Alert
 * @returns {JSX.Element} AntD Alert with defaults applied
 */
export const AppAlert = forwardRef<AlertRef, AlertProps>(function AppAlert({ type = 'info', icon, ...rest }, ref) {
  if (!icon) icon = appAlertIcons[type];

  return <Alert ref={ref} type={type} className="app-alert" icon={icon} {...rest} />;
});
